@if (
  !!asset &&
  (asset.additionalInfo.length > 0 ||
    asset.additionalDocuments.length > 0 ||
    InstallationData)
) {
  <div class="container" [class.mobile]="isMobile" [class.tablet]="isTablet">
    <div class="sensor-header">
      <i
        nz-icon
        nzType="icons:additional-information"
        class="sensor-icon svg-icon"
      ></i>
      <h2>{{ i18n.langString("additional_information") }}</h2>
    </div>
    @if (
      !!asset &&
      (asset.additionalInfo.length > 0 ||
        asset.additionalDocuments.length > 0 ||
        InstallationData)
    ) {
      <div class="additionalInformation">
        <nz-collapse [nzBordered]="false" [nzExpandIconPosition]="'end'">
          @if (asset?.additionalInfo?.length > 0) {
            <nz-collapse-panel
              #pA
              [nzHeader]="panelheaderA"
              [nzActive]="addInfo[0]"
              [nzExtra]="collapseIconA"
              (nzActiveChange)="addInfo[0] = $event"
              nzShowArrow="false"
            >
              @for (group of groupedInfoValues; track $index) {
                <ng-container>
                  @if (
                    group &&
                    group?.displayInfoValues &&
                    group?.displayInfoValues?.length > 0
                  ) {
                    <nz-list nzSize="small">
                      <nz-list-header class="info-type-name marginLeft">
                        <h3>{{ i18n.parse(group.infoType.name) }}</h3>
                      </nz-list-header>
                      <hr />
                      <nz-list nzSize="small" class="addInfo-list marginLeft">
                        @for (
                          addInfo of group.displayInfoValues;
                          track $index
                        ) {
                          <ng-container>
                            @if (addInfo.fieldType === "single") {
                              <nz-list-item class="regular addInfo-list-item">
                                <span class="body-bold-cap addInfo-label">{{
                                  addInfo.labelkey(i18n)
                                }}</span>
                                @if (addInfo.icon) {
                                  <i
                                    nz-icon
                                    [nzType]="'icons:done-full-circle'"
                                  ></i>
                                }
                                @if (addInfo.valueType) {
                                  <span>{{
                                    addInfo.value
                                      | unit
                                        : addInfo
                                        : i18n.pipeCompatibleMeasurementSystem()
                                  }}</span>
                                }
                                @if (!addInfo.valueType) {
                                  <span>{{ addInfo.text }}</span>
                                }
                              </nz-list-item>
                            }

                            @if (addInfo.fieldType === "dropdown") {
                              <nz-list-item class="regular addInfo-list-item">
                                <span class="body-bold-cap addInfo-label">{{
                                  addInfo.labelkey(i18n)
                                }}</span>
                                @if (addInfo.icon) {
                                  <i
                                    nz-icon
                                    [nzType]="'icons:done-full-circle'"
                                  ></i>
                                }
                                @if (addInfo.valueType) {
                                  <span>{{
                                    addInfo.value
                                      | unit
                                        : addInfo
                                        : i18n.pipeCompatibleMeasurementSystem()
                                  }}</span>
                                }

                                @if (!addInfo.valueType) {
                                  <span>{{ i18n.Parse(addInfo.text) }}</span>
                                }
                              </nz-list-item>
                            }

                            @if (
                              addInfo.fieldType === "multiple" &&
                              addInfo.multipleValues[0] &&
                              addInfo.multipleValues[0] !== ""
                            ) {
                              <nz-list-item class="regular addInfo-list-item">
                                <span class="body-bold-cap addInfo-label">{{
                                  addInfo.labelkey(i18n)
                                }}</span>
                                @for (
                                  value of addInfo.multipleValues;
                                  track $index
                                ) {
                                  <div>
                                    @if (addInfo.icon) {
                                      <i
                                        nz-icon
                                        [nzType]="'icons:done-full-circle'"
                                      ></i>
                                    }
                                    <span>{{ value }}</span>
                                  </div>
                                }
                              </nz-list-item>
                            }
                          </ng-container>
                        }
                      </nz-list>
                    </nz-list>
                  }
                </ng-container>
              }
              <ng-template #panelheaderA>
                <div class="collapse-header">
                  <i nz-icon [nzType]="'icons:info-about-equip'"></i>
                  <span class="body-bold">{{
                    i18n.langString("information_about_equipment")
                  }}</span>
                </div>
              </ng-template>
              <ng-template #collapseIconA let-active>
                @if (!addInfo[0]) {
                  <i nz-icon [nzType]="'icons:plus'"></i>
                }

                @if (addInfo[0]) {
                  <i nz-icon [nzType]="'icons:minus'"></i>
                }
              </ng-template>
            </nz-collapse-panel>
          }

          @if (InstallationData && showSensorData) {
            <nz-collapse-panel
              #pInstall
              [nzHeader]="panelheaderInstallation"
              [nzActive]="addInfo[1]"
              (nzActiveChange)="addInfo[1] = $event"
              [nzExtra]="collapseIconInstall"
              nzShowArrow="false"
            >
              @for (group of InstallationData; track $index) {
                <nz-list class="marginLeft" nzSize="small">
                  <nz-list-header class="body-bold-cap">{{
                    parseGroupHeader(group.header)
                  }}</nz-list-header>
                  @for (item of group.items; track $index) {
                    <nz-list-item class="regular">
                      <div>
                        @if(!!item.icon){
                          <i
                            nz-icon
                            [nzType]="'icons:' + item.icon"                        
                          ></i>
                        }
                        @if (!!item.text) {
                          <ng-container>
                            {{ i18n.parse(item.text) }}
                          </ng-container>
                        }

                        @if (!!item.value) {
                          <ng-container>
                            {{
                              item.value
                                | unit
                                  : item.valueType
                                  : i18n.pipeCompatibleMeasurementSystem()
                            }}
                          </ng-container>
                        }
                      </div>
                    </nz-list-item>
                  }
                </nz-list>
              }
              <ng-template #panelheaderInstallation>
                <div class="collapse-header">
                  <i nz-icon [nzType]="'icons:wifi'"></i>
                  <span class="body-bold">{{
                    i18n.langString("sensor_installation_data")
                  }}</span>
                </div>
              </ng-template>
              <ng-template #collapseIconInstall let-active>
                @if (!addInfo[1]) {
                  <i nz-icon [nzType]="'icons:plus'"></i>
                }

                @if (addInfo[1]) {
                  <i nz-icon [nzType]="'icons:minus'"></i>
                }
              </ng-template>
            </nz-collapse-panel>
          }

          @if (asset.additionalDocuments.length > 0) {
            <nz-collapse-panel
              #pB
              [nzHeader]="panelheaderB"
              [nzActive]="addInfo[2]"
              [nzExtra]="collapseIconB"
              (nzActiveChange)="addInfo[2] = $event"
              nzShowArrow="false"
              style="border: none"
            >
              <div class="image-wrapper">
                @for (doc of asset.additionalDocuments; track $index) {
                  <div class="single-image-wrapper">
                    <div class="photo-subwrapper">
                      <div class="file-preview">
                        <i
                          nz-icon
                          nzType="icons:file"
                          class="svg-icon mini-icon"
                        ></i>
                      </div>
                      <div class="body-bold text-center file-text">
                        {{ doc.filename }}
                      </div>
                      <app-nav-button
                        [primary]="true"
                        svgIcon="icons:eye"
                        class="additional-info-section"
                        (clickEvent)="openDocument(doc.storageLink)"
                        >{{ i18n.langString("show") }}
                      </app-nav-button>
                    </div>
                  </div>
                }
              </div>
              <ng-template #panelheaderB>
                <div class="collapse-header">
                  <i nz-icon [nzType]="'icons:documents'"></i>
                  <span class="body-bold">{{
                    i18n.langString("additional_documents")
                  }}</span>
                </div>
              </ng-template>
              <ng-template #collapseIconB let-active>
                @if (!addInfo[2]) {
                  <i nz-icon [nzType]="'icons:plus'"></i>
                }
                @if (addInfo[2]) {
                  <i nz-icon [nzType]="'icons:minus'"></i>
                }
              </ng-template>
            </nz-collapse-panel>
          }

          @if (HtstInfo) {
            <nz-collapse-panel
              #pInstallHtst
              [nzHeader]="panelheaderInstallationHtst"
              [nzActive]="addInfo[3]"
              (nzActiveChange)="addInfo[3] = $event"
              [nzExtra]="collapseIconInstallHtst"
              nzShowArrow="false"
            >
              <div class="htst-sensor-section">
                <div class="content-flex">
                  <div class="body-bold-cap">
                    {{ i18n.langString("sensor_installation_date") }}
                  </div>
                  <span class="date">{{ installationDate }}</span>
                </div>
                @if (inletHtstInfo) {
                  <app-htst-info-data-em
                    [htstInfo]="inletHtstInfo"
                    [sensorType]="'Inlet Sensor'"
                  ></app-htst-info-data-em>
                }

                @if (outletHtstInfo) {
                  <app-htst-info-data-em
                    [htstInfo]="outletHtstInfo"
                    [sensorType]="'Outlet Sensor'"
                  ></app-htst-info-data-em>
                }
              </div>
              <ng-template #panelheaderInstallationHtst>
                <div class="collapse-header">
                  <i nz-icon [nzType]="'icons:wifi'"></i>
                  <span class="body-bold">{{
                    i18n.langString("sensor_installation_data")
                  }}</span>
                </div>
              </ng-template>
              <ng-template #collapseIconInstallHtst let-active>
                @if (!addInfo[3]) {
                  <i nz-icon [nzType]="'icons:plus'"></i>
                }

                @if (addInfo[3]) {
                  <i nz-icon [nzType]="'icons:minus'"></i>
                }
              </ng-template>
            </nz-collapse-panel>
          }
        </nz-collapse>
      </div>
    }
  </div>
}

<nz-modal
  [(nzVisible)]="overlayImage"
  (nzOnCancel)="overlayImage = null"
  [nzFooter]="null"
  [nzCloseIcon]="'icons:exit'"
  [nzTitle]="i18n.langString('photo')"
>
  <img class="photo" src="{{ overlayImage }}" />
</nz-modal>
